/** Correlates Realtime responses to one player transmission, not just a connection. */
export class VoiceTurn {
  private serial = 0;
  id: string | null = null;
  responseId: string | null = null;
  begin(): string { this.id = String(++this.serial); this.responseId = null; return this.id; }
  cancel(): void { this.id = this.responseId = null; }
  created(response: { id?: string; metadata?: { atc_turn?: string } }): void {
    if (this.id && response.metadata?.atc_turn === this.id && typeof response.id === 'string') this.responseId = response.id;
  }
  matches(response: { id?: string; metadata?: { atc_turn?: string } }): boolean {
    return !!this.id && !!this.responseId && response.id === this.responseId && response.metadata?.atc_turn === this.id;
  }
}
